function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1940(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24.57,
    height: 14.29,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.0992307692307692
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 7.145
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14.29,
    width: 24.57,
    height: 21.05,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.007142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 24.814999999999998
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 35.34,
    width: 24.57,
    height: 21.88,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1257142857142854
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 46.28
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 57.22,
    width: 24.57,
    height: 25.33,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 69.88499999999999
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 82.55,
    width: 24.57,
    height: 26.16,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.07125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 95.63
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 108.7,
    width: 24.57,
    height: 27.75,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.19
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 122.575
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 136.45,
    width: 24.57,
    height: 27.88,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.07125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 150.39
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 164.33,
    width: 24.57,
    height: 29.34,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.095
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 179
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 193.68,
    width: 24.57,
    height: 32.41,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.095
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 209.885
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 226.08,
    width: 24.57,
    height: 32.53,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5100000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 242.34500000000003
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 258.62,
    width: 24.57,
    height: 33.17,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5100000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 275.205
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 291.79,
    width: 24.57,
    height: 33.36,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 308.47
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 325.15,
    width: 24.57,
    height: 33.56,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.457
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 341.92999999999995
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 358.71,
    width: 24.57,
    height: 34.32,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5100000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 375.87
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 393.03,
    width: 24.57,
    height: 34.58,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.095
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 410.32
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 427.6,
    width: 24.57,
    height: 36.62,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.07125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 445.91
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 464.22,
    width: 24.57,
    height: 37.51,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.914
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 482.975
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 501.73,
    width: 24.57,
    height: 39.23,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5100000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 521.345
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 540.96,
    width: 24.57,
    height: 39.62,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5100000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 560.77
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 580.58,
    width: 24.57,
    height: 39.68,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.07125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 600.4200000000001
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 620.26,
    width: 24.57,
    height: 39.87,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.095
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 640.1949999999999
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 660.13,
    width: 24.57,
    height: 39.87,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.095
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.285,
    y: 680.0649999999999
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.57,
    y: 0,
    width: 29.02,
    height: 34.73,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.145714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.08,
    y: 17.365
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.59,
    y: 0,
    width: 29.42,
    height: 34.73,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.202857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.30000000000001,
    y: 17.365
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.01,
    y: 0,
    width: 29.56,
    height: 34.73,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.222857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 97.79,
    y: 17.365
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.57,
    y: 0,
    width: 30.55,
    height: 34.73,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.81875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 127.845,
    y: 17.365
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.12,
    y: 0,
    width: 30.82,
    height: 34.73,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.136666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.53,
    y: 17.365
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.94,
    y: 0,
    width: 31.73,
    height: 34.73,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.288333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.805,
    y: 17.365
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205.67,
    y: 0,
    width: 31.86,
    height: 34.73,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.31
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 221.6,
    y: 17.365
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 237.53,
    y: 0,
    width: 32.27,
    height: 34.73,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.454000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 253.665,
    y: 17.365
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.79,
    y: 0,
    width: 34.43,
    height: 34.73,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.738333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 287.005,
    y: 17.365
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 304.23,
    y: 0,
    width: 34.43,
    height: 34.73,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.738333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 321.445,
    y: 17.365
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.66,
    y: 0,
    width: 34.61,
    height: 34.73,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.461
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 355.96500000000003,
    y: 17.365
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 373.27,
    y: 0,
    width: 34.75,
    height: 34.73,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.34125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.645,
    y: 17.365
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.02,
    y: 0,
    width: 34.84,
    height: 34.73,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.961428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 425.44,
    y: 17.365
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 442.86,
    y: 0,
    width: 35.74,
    height: 34.73,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.788333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 460.73,
    y: 17.365
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478.6,
    y: 0,
    width: 36.06,
    height: 34.73,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.473
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 496.63,
    y: 17.365
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 514.66,
    y: 0,
    width: 36.69,
    height: 34.73,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.961428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 533.005,
    y: 17.365
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551.35,
    y: 0,
    width: 36.73,
    height: 34.73,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.788333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 569.715,
    y: 17.365
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 588.08,
    y: 0,
    width: 36.87,
    height: 34.73,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.788333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 606.515,
    y: 17.365
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 624.95,
    y: 0,
    width: 37.23,
    height: 34.73,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.788333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 643.565,
    y: 17.365
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 662.18,
    y: 0,
    width: 37.82,
    height: 34.73,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.946
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 681.0899999999999,
    y: 17.365
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.57,
    y: 34.73,
    width: 37.94,
    height: 35.53,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.947777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.54,
    y: 52.495
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.57,
    y: 70.26,
    width: 37.94,
    height: 35.73,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.145999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.54,
    y: 88.125
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.57,
    y: 105.99,
    width: 37.94,
    height: 35.94,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.188
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.54,
    y: 123.96
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.57,
    y: 141.93,
    width: 37.94,
    height: 36.68,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.585
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.54,
    y: 160.27
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.57,
    y: 178.61,
    width: 37.94,
    height: 37.14,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.54,
    y: 197.18
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.57,
    y: 215.74,
    width: 37.94,
    height: 38.13,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.587999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.54,
    y: 234.805
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.57,
    y: 253.87,
    width: 37.94,
    height: 38.21,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.587999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.54,
    y: 272.975
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.57,
    y: 292.08,
    width: 37.94,
    height: 38.33,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.587999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.54,
    y: 311.245
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.57,
    y: 330.41,
    width: 37.94,
    height: 39.08,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.7425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.54,
    y: 349.95000000000005
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.57,
    y: 369.49,
    width: 37.94,
    height: 39.24,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7939999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.54,
    y: 389.11
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.57,
    y: 408.74,
    width: 37.94,
    height: 39.61,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.587999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.54,
    y: 428.545
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.57,
    y: 448.35,
    width: 37.94,
    height: 41.02,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.323333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.54,
    y: 468.86
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.57,
    y: 489.37,
    width: 37.94,
    height: 41.76,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.42
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.54,
    y: 510.25
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.57,
    y: 531.13,
    width: 37.94,
    height: 41.76,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.323333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.54,
    y: 552.01
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.57,
    y: 572.89,
    width: 37.94,
    height: 42.01,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.323333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.54,
    y: 593.895
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.57,
    y: 614.9,
    width: 37.94,
    height: 42.55,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.7425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.54,
    y: 636.175
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.57,
    y: 657.45,
    width: 37.94,
    height: 42.55,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.323333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.54,
    y: 678.725
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.51,
    y: 34.73,
    width: 38.04,
    height: 42.56,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.434285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 81.53,
    y: 56.01
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.55,
    y: 34.73,
    width: 38.22,
    height: 42.56,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.66,
    y: 56.01
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.77,
    y: 34.73,
    width: 38.3,
    height: 42.56,
    style: {
      fill: "#999999"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.471428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.92000000000002,
    y: 56.01
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.07,
    y: 34.73,
    width: 38.33,
    height: 42.56,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.79125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.23499999999999,
    y: 56.01
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 215.4,
    y: 34.73,
    width: 38.41,
    height: 42.56,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.6819999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 234.60500000000002,
    y: 56.01
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 253.81,
    y: 34.73,
    width: 38.81,
    height: 42.56,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.312222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 273.21500000000003,
    y: 56.01
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.62,
    y: 34.73,
    width: 38.92,
    height: 42.56,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.5600000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 312.08,
    y: 56.01
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 331.54,
    y: 34.73,
    width: 39.44,
    height: 42.56,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.573333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 351.26,
    y: 56.01
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 370.98,
    y: 34.73,
    width: 39.66,
    height: 42.56,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.9319999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.81,
    y: 56.01
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 410.64,
    y: 34.73,
    width: 39.92,
    height: 42.56,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 430.59999999999997,
    y: 56.01
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 450.56,
    y: 34.73,
    width: 40.54,
    height: 42.56,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.108
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 470.83,
    y: 56.01
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 491.1,
    y: 34.73,
    width: 40.95,
    height: 42.56,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 511.57500000000005,
    y: 56.01
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 532.05,
    y: 34.73,
    width: 41.57,
    height: 42.56,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.314
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 552.8349999999999,
    y: 56.01
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 573.62,
    y: 34.73,
    width: 41.72,
    height: 42.56,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.43
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 594.48,
    y: 56.01
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 615.34,
    y: 34.73,
    width: 42.24,
    height: 42.56,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 636.46,
    y: 56.01
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 657.58,
    y: 34.73,
    width: 42.42,
    height: 42.56,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.07
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 678.7900000000001,
    y: 56.01
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.51,
    y: 77.29,
    width: 45.12,
    height: 40.37,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.074
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.07,
    y: 97.47500000000001
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.51,
    y: 117.66,
    width: 45.12,
    height: 40.99,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.855714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.07,
    y: 138.155
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.51,
    y: 158.65,
    width: 45.12,
    height: 41.06,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.212
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.07,
    y: 179.18
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.51,
    y: 199.72,
    width: 45.12,
    height: 41.06,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.1325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.07,
    y: 220.25
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.51,
    y: 240.78,
    width: 45.12,
    height: 41.51,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.918333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.07,
    y: 261.535
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.51,
    y: 282.29,
    width: 45.12,
    height: 42.45,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.30625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.07,
    y: 303.51500000000004
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.51,
    y: 324.74,
    width: 45.12,
    height: 43.08,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.786666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.07,
    y: 346.28000000000003
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.51,
    y: 367.82,
    width: 45.12,
    height: 44.43,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.347142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.07,
    y: 390.03499999999997
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.51,
    y: 412.25,
    width: 45.12,
    height: 46.45,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.024
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.07,
    y: 435.475
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.51,
    y: 458.7,
    width: 45.12,
    height: 47.21,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.445714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.07,
    y: 482.305
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.51,
    y: 505.91,
    width: 45.12,
    height: 47.73,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.512
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.07,
    y: 529.775
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.51,
    y: 553.64,
    width: 45.12,
    height: 47.94,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.07,
    y: 577.61
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.51,
    y: 601.58,
    width: 45.12,
    height: 48.36,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.07,
    y: 625.76
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.51,
    y: 649.94,
    width: 45.12,
    height: 50.06,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.07,
    y: 674.97
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.63,
    y: 77.29,
    width: 46.61,
    height: 48.52,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.82625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 130.935,
    y: 101.55000000000001
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.24,
    y: 77.29,
    width: 47.03,
    height: 48.52,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.406
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.755,
    y: 101.55000000000001
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.27,
    y: 77.29,
    width: 48.71,
    height: 48.52,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.9314285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.625,
    y: 101.55000000000001
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.99,
    y: 77.29,
    width: 48.75,
    height: 48.52,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.704
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.365,
    y: 101.55000000000001
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.73,
    y: 77.29,
    width: 48.81,
    height: 48.52,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.9314285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.135,
    y: 101.55000000000001
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 347.54,
    y: 77.29,
    width: 48.84,
    height: 48.52,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.086666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 371.96000000000004,
    y: 101.55000000000001
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396.38,
    y: 77.29,
    width: 49.1,
    height: 48.52,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.9314285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 420.93,
    y: 101.55000000000001
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 445.48,
    y: 77.29,
    width: 49.1,
    height: 48.52,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.704
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 470.03000000000003,
    y: 101.55000000000001
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 494.58,
    y: 77.29,
    width: 49.91,
    height: 48.52,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.9314285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 519.535,
    y: 101.55000000000001
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 544.49,
    y: 77.29,
    width: 50.04,
    height: 48.52,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.086666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 569.51,
    y: 101.55000000000001
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 594.53,
    y: 77.29,
    width: 52.04,
    height: 48.52,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.086666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 620.55,
    y: 101.55000000000001
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 646.57,
    y: 77.29,
    width: 53.43,
    height: 48.52,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.704
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 673.2850000000001,
    y: 101.55000000000001
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.63,
    y: 125.81,
    width: 51.47,
    height: 50.49,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.415000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.365,
    y: 151.055
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.63,
    y: 176.3,
    width: 51.47,
    height: 50.97,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.37125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.365,
    y: 201.78500000000003
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.63,
    y: 227.27,
    width: 51.47,
    height: 51.43,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.347142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.365,
    y: 252.985
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.63,
    y: 278.7,
    width: 51.47,
    height: 51.52,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.578333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.365,
    y: 304.46
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.63,
    y: 330.22,
    width: 51.47,
    height: 51.58,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.578333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.365,
    y: 356.01000000000005
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.63,
    y: 381.8,
    width: 51.47,
    height: 51.67,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.294
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.365,
    y: 407.635
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.63,
    y: 433.47,
    width: 51.47,
    height: 52.1,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.8675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.365,
    y: 459.52000000000004
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.63,
    y: 485.57,
    width: 51.47,
    height: 52.5,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.294
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.365,
    y: 511.82
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.63,
    y: 538.07,
    width: 51.47,
    height: 52.53,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.294
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.365,
    y: 564.335
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.63,
    y: 590.59,
    width: 51.47,
    height: 53.93,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.352857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.365,
    y: 617.5550000000001
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.63,
    y: 644.52,
    width: 51.47,
    height: 55.48,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.43375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.365,
    y: 672.26
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.1,
    y: 125.81,
    width: 50.77,
    height: 56.77,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.461666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.48499999999999,
    y: 154.195
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.87,
    y: 125.81,
    width: 50.85,
    height: 56.77,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.264285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.29500000000002,
    y: 154.195
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.72,
    y: 125.81,
    width: 51.27,
    height: 56.77,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.254000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 286.355,
    y: 154.195
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 311.99,
    y: 125.81,
    width: 51.29,
    height: 56.77,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.41125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 337.635,
    y: 154.195
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 363.28,
    y: 125.81,
    width: 53.72,
    height: 56.77,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.953333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.14,
    y: 154.195
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 417,
    y: 125.81,
    width: 55.21,
    height: 56.77,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.887142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 444.605,
    y: 154.195
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 472.22,
    y: 125.81,
    width: 55.55,
    height: 56.77,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.935714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 499.995,
    y: 154.195
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 527.76,
    y: 125.81,
    width: 55.77,
    height: 56.77,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.967142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 555.645,
    y: 154.195
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 583.53,
    y: 125.81,
    width: 56.87,
    height: 56.77,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.461666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 611.9649999999999,
    y: 154.195
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 640.4,
    y: 125.81,
    width: 59.6,
    height: 56.77,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.461666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.1999999999999,
    y: 154.195
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.1,
    y: 182.58,
    width: 63.28,
    height: 54.74,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.82
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 190.74,
    y: 209.95000000000002
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.1,
    y: 237.33,
    width: 63.28,
    height: 56.23,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.247777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 190.74,
    y: 265.445
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.1,
    y: 293.55,
    width: 63.28,
    height: 56.62,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.0775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 190.74,
    y: 321.86
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.1,
    y: 350.18,
    width: 63.28,
    height: 56.67,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 190.74,
    y: 378.515
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.1,
    y: 406.85,
    width: 63.28,
    height: 56.85,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.370000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 190.74,
    y: 435.27500000000003
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.1,
    y: 463.7,
    width: 63.28,
    height: 58.36,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.484444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 190.74,
    y: 492.88
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.1,
    y: 522.05,
    width: 63.28,
    height: 58.48,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.31
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 190.74,
    y: 551.29
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.1,
    y: 580.54,
    width: 63.28,
    height: 59.3,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.86
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 190.74,
    y: 610.1899999999999
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.1,
    y: 639.83,
    width: 63.28,
    height: 60.17,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.028333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 190.74,
    y: 669.9150000000001
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.37,
    y: 182.58,
    width: 63.06,
    height: 60.52,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.565
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 253.9,
    y: 212.84
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.43,
    y: 182.58,
    width: 63.4,
    height: 60.52,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.086666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 317.13,
    y: 212.84
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 348.83,
    y: 182.58,
    width: 66.87,
    height: 60.52,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.565
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 382.265,
    y: 212.84
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.7,
    y: 182.58,
    width: 69.85,
    height: 60.52,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.724444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 450.625,
    y: 212.84
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.54,
    y: 182.58,
    width: 70.03,
    height: 60.52,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.645714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 520.5550000000001,
    y: 212.84
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 555.57,
    y: 182.58,
    width: 71.35,
    height: 60.52,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.645714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 591.245,
    y: 212.84
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 626.92,
    y: 182.58,
    width: 73.08,
    height: 60.52,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.645714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 663.4599999999999,
    y: 212.84
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.37,
    y: 243.1,
    width: 74.62,
    height: 61.08,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.108
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 259.68,
    y: 273.64
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.37,
    y: 304.19,
    width: 74.62,
    height: 62.11,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.351666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 259.68,
    y: 335.245
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.37,
    y: 366.3,
    width: 74.62,
    height: 62.72,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 259.68,
    y: 397.66
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.37,
    y: 429.02,
    width: 74.62,
    height: 65.2,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.3
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 259.68,
    y: 461.62
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.37,
    y: 494.22,
    width: 74.62,
    height: 66.17,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.028333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 259.68,
    y: 527.3050000000001
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.37,
    y: 560.38,
    width: 74.62,
    height: 67.7,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.4625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 259.68,
    y: 594.23
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.37,
    y: 628.08,
    width: 74.62,
    height: 71.92,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.986666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 259.68,
    y: 664.0400000000001
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.99,
    y: 243.1,
    width: 71.26,
    height: 76.04,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.815
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 332.62,
    y: 281.12
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 368.25,
    y: 243.1,
    width: 71.67,
    height: 76.04,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 404.085,
    y: 281.12
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439.92,
    y: 243.1,
    width: 83.01,
    height: 76.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.673333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 481.425,
    y: 281.12
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 522.92,
    y: 243.1,
    width: 85.73,
    height: 76.04,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.44888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 565.785,
    y: 281.12
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 608.65,
    y: 243.1,
    width: 91.35,
    height: 76.04,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.862857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 654.3249999999999,
    y: 281.12
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.99,
    y: 319.14,
    width: 93.75,
    height: 79.76,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.97
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 343.865,
    y: 359.02
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.99,
    y: 398.9,
    width: 93.75,
    height: 91.08,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.77
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 343.865,
    y: 444.44
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.99,
    y: 489.99,
    width: 93.75,
    height: 102,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.71875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 343.865,
    y: 540.99
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.99,
    y: 591.98,
    width: 93.75,
    height: 108.02,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 343.865,
    y: 645.99
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.74,
    y: 319.14,
    width: 78.52,
    height: 129.91,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.815
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 430,
    y: 384.09499999999997
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 469.26,
    y: 319.14,
    width: 98.17,
    height: 129.91,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 24.5425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 518.345,
    y: 384.09499999999997
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 567.43,
    y: 319.14,
    width: 132.57,
    height: 129.91,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.651666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 633.7149999999999,
    y: 384.09499999999997
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.74,
    y: 449.05,
    width: 75.27,
    height: 250.95,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.752857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 428.375,
    y: 574.525
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 466.01,
    y: 449.05,
    width: 233.99,
    height: 250.95,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 38.998333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 583.005,
    y: 574.525
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1940);
export default __webpack_public_path__ + "static/media/1940.4bd7a76a55feca3a56c4867ad91c44ad.svg";
export { ForwardRef as ReactComponent };